import React, { useEffect, useState } from 'react';
import useRaffles from '../hooks/useRaffles';

const RaffleStatusBadge = ({ raffleKey }) => {
  const raffle = useRaffles(raffleKey);

  const [raffleStarted, setRaffleStarted] = useState(false);
  const [raffleEnded, setRaffleEnded] = useState(false);

  const [raffleStart, setRaffleStart] = useState(new Date(0));
  const [raffleEnd, setRaffleEnd] = useState(new Date());

  useEffect(() => {
    setRaffleStart(new Date(raffle.start_time));
    setRaffleEnd(new Date(raffle.end_time));
  }, [raffle]);

  useEffect(() => {
    const updateRaffleState = () => {
      setRaffleStarted(raffleStart.getTime() < Date.now());
      setRaffleEnded(raffleEnd.getTime() < Date.now());
    };
    updateRaffleState();
    const intervalId = setInterval(updateRaffleState, 10000);
    return () => clearInterval(intervalId);
  }, [raffleStart, raffleEnd]);

  if (raffleEnded) {
    return <span className="badge rounded-pill bg-secondary">Ended</span>;
  }

  if (raffleStarted) {
    return <span className="badge rounded-pill bg-success">Active</span>;
  }

  return <span className="badge rounded-pill bg-primary">Upcoming</span>;
};

export default RaffleStatusBadge;
